import { Link } from "react-router-dom";
import { ShieldCheck } from "@phosphor-icons/react";

export const CONSENT_VERSION = "v1-2026-11";
export const CONSENT_TEXT = "Saya telah membaca dan menyetujui Kebijakan Privasi HaloGBS. Saya mengizinkan Griya Bunda Sehat memproses data pribadi dan data kesehatan saya untuk reservasi, pelayanan kesehatan, pembayaran, dan pengiriman notifikasi, termasuk penyimpanan di server di luar Indonesia.";

export function PrivacyConsentBox({ checked, onChange, testid = "privacy-consent" }) {
  return (
    <label data-testid={`${testid}-label`} className="flex items-start gap-2.5 rounded-xl border border-[#E0D2FF] bg-[#FAF7FF] p-3 text-xs leading-relaxed text-slate-700">
      <input data-testid={testid} type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} className="mt-0.5 h-4 w-4 shrink-0 accent-[#7C4DE0]" />
      <span>
        {CONSENT_TEXT.split("Kebijakan Privasi HaloGBS")[0]}
        <Link to="/kebijakan-privasi" target="_blank" data-testid={`${testid}-link`} className="font-bold text-[#7C4DE0] underline">Kebijakan Privasi HaloGBS</Link>
        {CONSENT_TEXT.split("Kebijakan Privasi HaloGBS")[1]}
      </span>
    </label>
  );
}

export function DataSafeNote() {
  return (
    <p data-testid="data-safe-note" className="mt-3 flex items-start gap-1.5 text-[11px] text-slate-500">
      <ShieldCheck size={14} weight="duotone" className="mt-px shrink-0 text-[#7C4DE0]" />
      Data Anda dijaga kerahasiaannya dan hanya dipakai untuk layanan Griya Bunda Sehat.
    </p>
  );
}

export function PrivacyFooter() {
  return (
    <footer data-testid="privacy-footer" className="border-t border-slate-100 bg-white/80 px-4 py-3 text-center text-[11px] text-slate-500">
      © Griya Bunda Sehat · <Link to="/kebijakan-privasi" data-testid="footer-privacy-link" className="font-semibold text-[#7C4DE0] hover:underline">Kebijakan Privasi</Link>
    </footer>
  );
}
